export enum AccountTypes {
    Premium = "premium",
    Freemium = "freemium",
    PremiumAI = "premiumai",
}

export interface AccountInfo {
    total_events_created: number;
    event_limit: number | null;
    type: AccountTypes;
}
export interface IUserData {
    account_type: string;
    account: AccountInfo;
    active?: boolean;
    avatar?: {
        public_url?: string;
        fid?: string;
    };
    email: string;
    gender: string;
    groups?: string[];
    id: string;
    lang: string;
    profession?: string;
    date_range?: string;
    restrictions: {
        branded_qr: number;
        data_reports: number;
    };
    username: string;
}

export interface IUserUpdateData {
    username?: string;
    email?: string;
    avatar?: string;
    profession?: string;
}

export interface IUpdateSettingsResponse {
    data?: {
        user_id: string;
        username: string;
        lang: string;
        gender: string;
        email: string;
        groups: string[];
        active: boolean;
        avatar: string;
        profession?: string;
    };
    message?: string;
    success: boolean;
}

export interface IUserInfo {
    account_type: string;
    account: AccountInfo;
    avatar?: {
        public_url?: string;
        fid?: string;
    };
    email: string;
    lang: string;
    profession: string;
    date_range: string;
    restrictions: {
        data_reports: number;
        branded_qr: number;
    };
    user_id: string;
    username: string;
}
export interface IUserRestrictionsResponse {
    data: IUserInfo;
    success: boolean;
}

export interface IRestrictions {
    data_reports: number;
    branded_qr: number;
}
